import React from 'react';
import ReactDOM from 'react-dom/client';
import "bootstrap/dist/css/bootstrap.min.css"
import { BrowserRouter } from 'react-router-dom';
import './setupApiCredentials';
import App from './App';



 ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
<BrowserRouter basename="/">
     <App />
    </BrowserRouter>
   
  </React.StrictMode>
)



